<template>
  <div class="liuxuan-test-system-tip-2019">
    “刘轩”邀请你加入了“<span>精准扶教家长群</span>”群聊，群聊参与人还有：方圆、宋倩、季胜利、夏东海 、刘梅
  </div>
</template>

<script>
  export default {
    name: 'LiuXuanTestSystemTip2019',
    created() {
      setTimeout(() => {
        this.$emit('addShowBlockCount');
        document.getElementById('page-end').scrollIntoView();
      }, 1000);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .liuxuan-test-system-tip-2019 {
    width: 630px;
    margin: 0 auto @size-large;
    padding: @size-base;
    box-sizing: border-box;
    background: #f2f2f2;
    color: @color-text-lighter;
    font-size: @font-size-small;
    line-height: 2.2;
    border-radius: @border-radius-medium / 2;
    span {
      color: #37aba8;
    }
  }

</style>
